import { environment } from 'src/environments/environment';
import { AdminService } from './../../../services/admin.service';
import { UserService } from 'src/app/services/user.service';
import { SeriesService } from './../../../services/series.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { SeriesNavigationComponent } from '../series-navigation/series-navigation.component';
import { PlyrComponent } from 'ngx-plyr';
import * as Plyr from 'plyr';
import { first } from 'rxjs/internal/operators/first';
import { UserNavigationComponent } from 'src/app/partials/navigation/user-navigation/user-navigation.component';
import * as jquery from 'jquery';
import { map, tap, concatMap } from 'rxjs/operators';
import { MinuteSecondsPipe } from 'src/app/helpers/pipes/minuteSeconds.pipe';
import * as NTW from 'number-to-words';
import { AuthService } from 'src/app/services/auth.service';
import { Role } from 'src/app/models';
import { StateChange } from 'ng-lazyload-image';

declare var require: any;

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss'],
  providers: [ MinuteSecondsPipe ]
})
export class VideosComponent implements OnInit {

  @ViewChild(UserNavigationComponent) userNavigation;
  @ViewChild(SeriesNavigationComponent) seriesNavigation;
  @ViewChild(PlyrComponent, { static: true }) plyr: PlyrComponent;

  series: any;
  error = false;
  preloaderImage = require('../../../../assets/images/loader-big.svg');
  module: any;
  seriesId: number;
  moduleId: number;
  modalText = 'Loading...';
  nonAdminRoles = [Role.Individual, Role.Manager, Role.Employee];

  videosActive: any;
  exerciseActive: any;
  quizActive: any;
  summaryActive: any;

  // Video Player
  videoPlayer: Plyr;
  activeModuleNo: number;
  activeModuleName: string;
  activeModuleBgColor: string;
  activeModuleQuiz: 0;
  activeModuleSummary: 0;

  videoWatchTime = 0;
  videoCurrentWatchTime = 0;
  videoDuration = 0;
  videoInterval: any;
  videoAcceptableSkipSeconds = environment.videoAcceptableSkipSeconds;
  videoRemainingSecondsToUpdateScore = environment.videoRemainingSecondsToUpdateScore;
  updateScore = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pageTitleService: Title,
    private seriesService: SeriesService,
    private userService: UserService,
    private adminService: AdminService,
    private authService: AuthService,
    private toMinute: MinuteSecondsPipe,
  ) { }

  ngOnInit(): void {
    this.setPageTitle();
    this.getRouteParams();
    this.removeUserIconPadding();

    const currentRole = this.authService.currentUserValue.role;
    if (currentRole && this.nonAdminRoles.indexOf(currentRole) >= 0) {
      this.loadData();
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response && response.data.role === Role.Admin) {
            this.loadAdminData();
          } else {
            this.loadData();
          }
        });
    }

  }

  private removeUserIconPadding(): void {
    jquery(window).scroll(function() {
      if (jquery(this).scrollTop() > 50) {
        jquery('nav a').removeClass('reduced-padding');
        jquery('nav ul').removeClass('mt-1');
      }
    });
  }

  private setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Videos');
  }

  private getRouteParams() {
    this.seriesId = this.route.snapshot.params.seriesId;
    this.moduleId = this.route.snapshot.params.moduleId;

    this.videosActive = this.route.snapshot.queryParamMap.get('video_active');
    this.exerciseActive = this.route.snapshot.queryParamMap.get('exercise_active');
    this.quizActive = this.route.snapshot.queryParamMap.get('quiz_active');
    this.summaryActive = this.route.snapshot.queryParamMap.get('summary_active');

  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    this.userService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => this.userNavigation.user = user),

        // Get Series
        concatMap(() => this.seriesService.getSeries()),
        map(series => series.data.series),
        tap(series => {
          let moduleCount = 0;
          series.map(seriesData => {
            let words = NTW.toWords(seriesData.sequence_number + 1);
            words = words.charAt(0).toUpperCase() + words.slice(1);
            return seriesData.sequence_number = words;
          });
          this.seriesNavigation.series = series;
          this.series = series;

          // Gets the Video duration
          this.seriesNavigation.series.forEach(seriesData => {
            return seriesData.modules.forEach(module => {
              module.video_duration = this.toMinute.transform(module.video_duration);

              // Sets module total available points
              let totalAvailablePoints = 10;

              if (module.quiz == 1) {
                totalAvailablePoints += 5;
              }

              if (module.summary == 1) {
                totalAvailablePoints += 5;
              }

              module.totalAvailablePoints = totalAvailablePoints;

              // Sets the module count
              moduleCount += 1;
              module.moduleNo = moduleCount;

              // set values for the description under the fixed video
              if (module.id == this.moduleId) {
                this.activeModuleNo = module.moduleNo;
                this.activeModuleName = module.name;
                this.activeModuleBgColor = module.cover_color;
                this.activeModuleQuiz = module.quiz;
                this.activeModuleSummary = module.summary;
              }

            });
          });
        }),

        // Get Video Url
        concatMap(() => this.seriesService.getSeriesModules(this.seriesId)),
        map(module => module.data.series.modules),
        tap(module => {
          this.module = module.find(data => data.id == this.moduleId);

          // Pass data to UserNavigation component
          this.userNavigation.mobileNavText = 'Video';
          this.userNavigation.seriesId = this.seriesId;
          this.userNavigation.moduleId = this.moduleId;
          this.userNavigation.hasModuleQuiz = (this.module.quiz?.length > 0) ? true : false;
          this.userNavigation.hasModuleSummary = (this.module.summary?.length > 0) ? true : false;
        }),

        // Get User Statistics
        concatMap(() => this.userService.getUserStatistics()),
        map(stats => stats.data.tasks_completed),
        tap(stats => {
          const completedModules = stats.by_modules;

          if (completedModules.length > 0) {
            this.seriesNavigation.series.forEach(seriesData => {
                return seriesData.modules.forEach(module => {
                  completedModules.forEach(cSeries => {
                    cSeries.modules.forEach(cModule => {

                      // Get Video Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('video')) {
                        module.video_completed = true;
                      }

                      // Get Quiz Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('quiz')) {
                        module.quiz_completed = true;
                      }

                      // Get Exercise Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('exercise')) {
                        module.exercise_completed = true;
                      }

                      // Get Summary Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('summary')) {
                        module.summary_completed = true;
                      }

                      // Get Module Points
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('module_points')) {
                        module.points = cModule.module_points;
                      }
                    });
                  });
                });
              });
          }
        }),

      )
      .subscribe(
        response => {
          if (response) {
            // hide progress modal
            this.hideProgressModal();

            // Module Scrolling
            this.seriesNavigation.scrollToSpecificModule();

            // Scroll to specific module on series mobile navigation
            this.scrollToSpecificModuleMobile();
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  loadAdminData() {

    // Show progress modal
    this.showProgressModal();

    this.adminService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => this.userNavigation.user = user),

        // Get Series
        concatMap(() => this.seriesService.getSeriesAdminDashboard()),
        map(series => series.data.series),
        tap(series => {
          let moduleCount = 0;
          series.map(seriesData => {
            let words = NTW.toWords(seriesData.sequence_number + 1);
            words = words.charAt(0).toUpperCase() + words.slice(1);
            return seriesData.sequence_number = words;
          });
          this.seriesNavigation.series = series;
          this.series = series;

          // Gets the Video duration
          this.seriesNavigation.series.forEach(seriesData => {
            return seriesData.modules.forEach(module => {
              module.video_duration = this.toMinute.transform(module.video_duration);

              // Sets module total available points
              let totalAvailablePoints = 10;

              if (module.quiz == 1) {
                totalAvailablePoints += 5;
              }

              if (module.summary == 1) {
                totalAvailablePoints += 5;
              }

              module.totalAvailablePoints = totalAvailablePoints;

              // Sets the module count
              moduleCount += 1;
              module.moduleNo = moduleCount;

              // set values for the description under the fixed video
              if (module.id == this.moduleId) {
                this.activeModuleNo = module.moduleNo;
                this.activeModuleName = module.name;
                this.activeModuleBgColor = module.cover_color;
                this.activeModuleQuiz = module.quiz;
                this.activeModuleSummary = module.summary;
              }

            });
          });
        }),

        // Get Video Url
        concatMap(() => this.seriesService.getSeriesModulesAdminDashboard(this.seriesId)),
        map(module => module.data.series.modules),
        tap(module => {
          this.module = module.find(data => data.id == this.moduleId);

          // Pass data to UserNavigation component
          this.userNavigation.mobileNavText = 'Video';
          this.userNavigation.seriesId = this.seriesId;
          this.userNavigation.moduleId = this.moduleId;
          this.userNavigation.hasModuleQuiz = (this.module.quiz?.length > 0) ? true : false;
          this.userNavigation.hasModuleSummary = (this.module.summary?.length > 0) ? true : false;
        }),

        // Get User Statistics
        concatMap(() => this.adminService.getUserStatistics()),
        map(stats => stats.data.tasks_completed),
        tap(stats => {
          const completedModules = stats.by_modules;

          if (completedModules.length > 0) {
            this.seriesNavigation.series.forEach(seriesData => {
                return seriesData.modules.forEach(module => {
                  completedModules.forEach(cSeries => {
                    cSeries.modules.forEach(cModule => {

                      // Get Video Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('video')) {
                        module.video_completed = true;
                      }

                      // Get Quiz Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('quiz')) {
                        module.quiz_completed = true;
                      }

                      // Get Exercise Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('exercise')) {
                        module.exercise_completed = true;
                      }

                      // Get Summary Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('summary')) {
                        module.summary_completed = true;
                      }

                      // Get Module Points
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('module_points')) {
                        module.points = cModule.module_points;
                      }
                    });
                  });
                });
              });
          }
        }),

      )
      .subscribe(
        response => {
          if (response) {
            // hide progress modal
            this.hideProgressModal();

            // Module Scrolling
            this.seriesNavigation.scrollToSpecificModule();

            // Scroll to specific module on series mobile navigation
            this.scrollToSpecificModuleMobile();

          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  private scrollToSpecificModuleMobile(): void {

    // Scroll to specific module on series mobile navigation
    /*
    const moduleTitleContainer: HTMLElement = document.getElementById('mobile_module_scroll_' + this.seriesId + '_' + this.moduleId);
    const moduleScrollTop = moduleTitleContainer.getBoundingClientRect().top;
    setTimeout(() => {
      jquery('html, body').animate({
        scrollTop: moduleScrollTop - 250
      }, 1000);
    }, 1000);
    */

    // let el = document.getElementById('mobile_module_scroll_' + this.seriesId + '_' + this.moduleId +'');
    // el.scrollIntoView({behavior: 'smooth'});
  }

  ended(event: Plyr.PlyrEvent) {

    const currentRole = this.authService.currentUserValue.role;
    if (currentRole && this.nonAdminRoles.indexOf(currentRole) >= 0) {
      this.updateNormalUser();
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response && response.data.role === Role.Admin) {
            this.updateAdminUser();
          } else {
            this.updateNormalUser();
          }
        });
    }

  }

  timeupdate(event: Plyr.PlyrEvent) {
    this.updateUserScores();
    this.videoCurrentWatchTime = Math.floor(this.videoPlayer.currentTime);
  }

  play(event: Plyr.PlyrEvent) {
    this.videoInterval = setInterval(() => {
      this.videoWatchTime++;
    }, 1000);

    this.videoDuration = Math.floor(this.videoPlayer.duration);
  }

  pause(event: Plyr.PlyrEvent) {
    clearInterval(this.videoInterval);
    this.videoCurrentWatchTime = Math.floor(this.videoPlayer.currentTime);
  }

  seeking(event: Plyr.PlyrEvent) {
    this.updateUserScores();
    this.videoCurrentWatchTime = Math.floor(this.videoPlayer.currentTime);
  }

  private updateUserScores() {
    const watchTime = (this.videoCurrentWatchTime > 0) ? this.videoCurrentWatchTime : this.videoWatchTime;
    const remainingVideoSeconds = this.videoDuration - watchTime;

    if (this.videoWatchTime > this.videoAcceptableSkipSeconds && remainingVideoSeconds <= this.videoRemainingSecondsToUpdateScore
        && !this.updateScore) {

      clearInterval(this.videoInterval);

      const currentRole = this.authService.currentUserValue.role;
      if (currentRole && this.nonAdminRoles.indexOf(currentRole) >= 0) {
        this.updateNormalUser(false);
      } else {
        this.authService.getTokenDetails(this.authService.tokenValue)
          .subscribe(response => {
            if (response && response.data.role === Role.Admin) {
              this.updateAdminUser(false);
            } else {
              this.updateNormalUser(false);
            }
          });
      }

      this.updateScore = true;

    }

  }

  private updateNormalUser(reloadPage = true) {
    let willUpdateStats = false;
    let showExerciseConfirmation = false;
    let hasQuizAndSummaryTasks = false;

    if (this.module.quiz?.length > 0 || this.module.summary?.length > 0) {
      hasQuizAndSummaryTasks = true;
    }

    this.userService.getUserStatistics()
      .pipe(first())
      .subscribe(
        statsData => {
          if (statsData.success) {
            if (statsData.data.tasks_completed.by_modules.length > 0) {
              const completedModules: any = statsData.data.tasks_completed.by_modules;

              // Check Video Completion Status
              for (let i = 0; i < completedModules.length; i++) {
                for (let x = 0; x < completedModules[i].modules.length; x++) {
                  // If not exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId
                    && !completedModules[i].modules[x].hasOwnProperty('video')) {
                      willUpdateStats = true;
                      break;
                  }
                  // If exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId
                    && completedModules[i].modules[x].hasOwnProperty('video')) {
                      willUpdateStats = false;
                      break;
                  }
                  // If there's no any completed tasks on the current series yet
                  if (completedModules[i].series_id == this.seriesId &&
                      completedModules[i].modules.filter(item => item.module_id == this.moduleId).length == 0) {
                    willUpdateStats = true;
                    break;
                  }
                  // If current series id does not exists on the completed modules
                  if (completedModules.filter(item => item.series_id == this.seriesId).length == 0) {
                    willUpdateStats = true;
                    break;
                  }
                }
              }

              // Check Breath Exercise Completion Status
              for (let i = 0; i < completedModules.length; i++) {
                for (let x = 0; x < completedModules[i].modules.length; x++) {
                  // If not exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId
                    && !completedModules[i].modules[x].hasOwnProperty('exercise')) {
                      showExerciseConfirmation = true;
                      break;
                  }
                  // If exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId
                    && completedModules[i].modules[x].hasOwnProperty('exercise')) {
                      showExerciseConfirmation = false;
                      break;
                  }
                  // If there's no any completed tasks on the current series yet
                  if (completedModules[i].series_id == this.seriesId &&
                      completedModules[i].modules.filter(item => item.module_id == this.moduleId).length == 0) {
                    showExerciseConfirmation = true;
                    break;
                  }
                  // If current series id does not exists on the completed modules
                  if (completedModules.filter(item => item.series_id == this.seriesId).length == 0) {
                    showExerciseConfirmation = true;
                    break;
                  }
                }
              }

              // Update User Stats
              if (willUpdateStats) {
                this.updateUserStats(showExerciseConfirmation, hasQuizAndSummaryTasks, reloadPage);
              } else {
                if (reloadPage) {
                  if (!hasQuizAndSummaryTasks) {
                    // Show Breath Exercise Confirmation
                    jquery('#exerciseConfirmation').show();
                  } else {
                    if (this.module.quiz?.length > 0) {
                      // Redirect to Quiz if exists
                      this.router.navigate(['/user/quiz/' + this.seriesId + '/' + this.moduleId], {
                        queryParams: {
                          quiz_active: true
                        }
                      });
                    } else if (this.module.summary?.length > 0) {
                      // Redirect to Summary if exists
                      this.router.navigate(['/user/summary/' + this.seriesId + '/' + this.moduleId], {
                        queryParams: {
                          summary_active: true
                        }
                      });
                    } else {
                      // Redirect to Dashboard
                      this.router.navigate(['/user/dashboard']);
                    }
                  }
                }
              }

            }
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  private updateAdminUser(reloadPage = true) {
    let willUpdateStats = false;
    let showExerciseConfirmation = false;
    let hasQuizAndSummaryTasks = false;

    if (this.module.quiz?.length > 0 || this.module.summary?.length > 0) {
      hasQuizAndSummaryTasks = true;
    }

    this.adminService.getUserStatistics()
      .pipe(first())
      .subscribe(
        statsData => {
          if (statsData.success) {
            if (statsData.data.tasks_completed.by_modules.length > 0) {
              const completedModules: any = statsData.data.tasks_completed.by_modules;

              // Check Video Completion Status
              for (let i = 0; i < completedModules.length; i++) {
                for (let x = 0; x < completedModules[i].modules.length; x++) {
                  // If not exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId
                    && !completedModules[i].modules[x].hasOwnProperty('video')) {
                      willUpdateStats = true;
                      break;
                  }
                  // If exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId
                    && completedModules[i].modules[x].hasOwnProperty('video')) {
                      willUpdateStats = false;
                      break;
                  }
                  // If there's no any completed tasks on the current series yet
                  if (completedModules[i].series_id == this.seriesId &&
                      completedModules[i].modules.filter(item => item.module_id == this.moduleId).length == 0) {
                    willUpdateStats = true;
                    break;
                  }
                  // If current series id does not exists on the completed modules
                  if (completedModules.filter(item => item.series_id == this.seriesId).length == 0) {
                    willUpdateStats = true;
                    break;
                  }
                }
              }

              // Check Breath Exercise Completion Status
              for (let i = 0; i < completedModules.length; i++) {
                for (let x = 0; x < completedModules[i].modules.length; x++) {
                  // If not exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId
                    && !completedModules[i].modules[x].hasOwnProperty('exercise')) {
                      showExerciseConfirmation = true;
                      break;
                  }
                  // If exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId
                    && completedModules[i].modules[x].hasOwnProperty('exercise')) {
                      showExerciseConfirmation = false;
                      break;
                  }
                  // If there's no any completed tasks on the current series yet
                  if (completedModules[i].series_id == this.seriesId &&
                      completedModules[i].modules.filter(item => item.module_id == this.moduleId).length == 0) {
                    showExerciseConfirmation = true;
                    break;
                  }
                  // If current series id does not exists on the completed modules
                  if (completedModules.filter(item => item.series_id == this.seriesId).length == 0) {
                    showExerciseConfirmation = true;
                    break;
                  }
                }
              }

              // Update User Stats
              if (willUpdateStats) {
                this.updateAdminUserStats(showExerciseConfirmation, hasQuizAndSummaryTasks, reloadPage);
              } else {
                if (reloadPage) {
                  if (!hasQuizAndSummaryTasks) {
                    // Show Breath Exercise Confirmation
                    jquery('#exerciseConfirmation').show();
                  } else {
                    if (this.module.quiz?.length > 0) {
                      // Redirect to Quiz if exists
                      this.router.navigate(['/user/quiz/' + this.seriesId + '/' + this.moduleId], {
                        queryParams: {
                          quiz_active: true
                        }
                      });
                    } else if (this.module.summary?.length > 0) {
                      // Redirect to Summary if exists
                      this.router.navigate(['/user/summary/' + this.seriesId + '/' + this.moduleId], {
                        queryParams: {
                          summary_active: true
                        }
                      });
                    } else {
                      // Redirect to Dashboard
                      this.router.navigate(['/user/dashboard']);
                    }
                  }
                }
              }

            }
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  updateUserStats(showExerciseConfirmation: boolean, hasQuizAndSummaryTasks: boolean, reloadPage = true) {
    // Updates User Stats when video is finished playing
    this.userService.updateUserStatistics(this.moduleId, 'video')
    .pipe(first())
    .subscribe(
      data => {
        if (data.success) {
          if (reloadPage) {
            if (!hasQuizAndSummaryTasks) {
              // Show Breath Exercise Confirmation
              jquery('#exerciseConfirmation').show();
            } else {
              if (this.module.quiz?.length > 0) {
                // Redirect to Quiz if exists
                this.router.navigate(['/user/quiz/' + this.seriesId + '/' + this.moduleId], {
                  queryParams: {
                    quiz_active: true
                  }
                });
              } else if (this.module.summary?.length > 0) {
                // Redirect to Summary if exists
                this.router.navigate(['/user/summary/' + this.seriesId + '/' + this.moduleId], {
                  queryParams: {
                    summary_active: true
                  }
                });
              } else {
                // Redirect to Dashboard
                this.router.navigate(['/user/dashboard']);
              }
            }
            return;
          }
          // Update user points without reloading
          this.userNavigation.user.points_earned = data.user.points_earned;
        }
      },
      error => {
        // hide progress modal
        this.hideProgressModal();
        this.error = true;
      }
    );
  }

  updateAdminUserStats(showExerciseConfirmation: boolean, hasQuizAndSummaryTasks: boolean, reloadPage = true) {
    // Updates User Stats when video is finished playing
    this.adminService.updateUserStatistics(this.moduleId, 'video')
    .pipe(first())
    .subscribe(
      data => {
        if (data.success) {
          if (reloadPage) {
            if (!hasQuizAndSummaryTasks) {
              // Show Breath Exercise Confirmation
              jquery('#exerciseConfirmation').show();
            } else {
              if (this.module.quiz?.length > 0) {
                // Redirect to Quiz if exists
                this.router.navigate(['/user/quiz/' + this.seriesId + '/' + this.moduleId], {
                  queryParams: {
                    quiz_active: true
                  }
                });
              } else if (this.module.summary?.length > 0) {
                // Redirect to Summary if exists
                this.router.navigate(['/user/summary/' + this.seriesId + '/' + this.moduleId], {
                  queryParams: {
                    summary_active: true
                  }
                });
              } else {
                // Redirect to Dashboard
                this.router.navigate(['/user/dashboard']);
              }
            }
            return;
          }
          // Update user points without reloading
          this.userNavigation.user.points_earned = data.user.points_earned;
        }
      },
      error => {
        // hide progress modal
        this.hideProgressModal();
        this.error = true;
      }
    );
  }

  showModuleLinks(seriesId: number, moduleId: number) {
    jquery('#mobile_module_' + seriesId + '_' + moduleId).slideToggle();
    setTimeout(() => {
      const isCollapsed = jquery('#mobile_module_' + seriesId + '_' + moduleId).is(':visible');
      const moduleTitleContainer: HTMLElement = document.getElementById('mobile_module_title_' + seriesId + '_' + moduleId);
      const moduleTitleIcon: HTMLElement = document.getElementById('mobile_module_title_icon_' + seriesId + '_' + moduleId);

      if (isCollapsed) {
        moduleTitleContainer?.classList.add('add-border-bottom');
        moduleTitleContainer?.classList.add('resize-module-title-box');

        moduleTitleIcon?.classList.remove('fa-angle-down');
        moduleTitleIcon?.classList.add('fa-angle-up');
      } else {
        moduleTitleContainer?.classList.remove('add-border-bottom');
        moduleTitleContainer?.classList.remove('resize-module-title-box');
        moduleTitleIcon?.classList.remove('fa-angle-up');
        moduleTitleIcon?.classList.add('fa-angle-down');
      }
    }, 500);
  }

  moduleImageCallback(event: StateChange, seriesId: number, moduleId: number) {
    switch (event.reason) {
      case 'setup':
        // The lib has been instantiated but we have not done anything yet.
        const imageContainerOnInit: HTMLElement = document.getElementById('mobile_module_image_' + seriesId + '_' + moduleId);
        imageContainerOnInit?.classList.add('module-image-loading');
        break;
      case 'observer-emit':
        // The image observer (intersection/scroll observer) has emit a value so we
        // should check if the image is in the viewport.
        // `event.data` is the event in this case.
        break;
      case 'start-loading':
        // The image is in the viewport so the image will start loading
        break;
      case 'mount-image':
        // The image has been loaded successfully so lets put it into the DOM
        break;
      case 'loading-succeeded':
        // The image has successfully been loaded and placed into the DOM
        const imageContainerAfterInit: HTMLElement = document.getElementById('mobile_module_image_' + seriesId + '_' + moduleId);
        imageContainerAfterInit?.classList.remove('module-image-loading');
        const imageParentContainerAfterInit: HTMLElement = document.getElementById('mobile_module_image_container_' + seriesId + '_' + moduleId);
        imageParentContainerAfterInit?.classList.remove('d-flex');
        imageContainerAfterInit?.classList.add('module-image-fit');

        // Module Points
        const moduleBadgePointsContainer: HTMLElement = document.getElementById('mobile_module_badge_points_' + seriesId + '_' + moduleId);
        moduleBadgePointsContainer?.classList.remove('d-none');
        moduleBadgePointsContainer?.classList.add('d-inline');

        // Module Video Status
        const moduleBadgeVideoContainer: HTMLElement = document.getElementById('mobile_module_badge_video_' + seriesId + '_' + moduleId);
        moduleBadgeVideoContainer?.classList.remove('d-none');
        moduleBadgeVideoContainer?.classList.add('d-inline');

        // Module Video Duration
        const moduleBadgeVideoDurationContainer: HTMLElement = document.getElementById('mobile_module_badge_video_duration_' + seriesId + '_' + moduleId);
        moduleBadgeVideoDurationContainer?.classList.remove('d-none');
        moduleBadgeVideoDurationContainer?.classList.add('d-inline');

        // Module Play Button
        const playButtonContainer: HTMLElement = document.getElementById('mobile_module_play_' + seriesId + '_' + moduleId);
        playButtonContainer?.classList.add('mobile-badge-play');

        break;
      case 'loading-failed':
        // The image could not be loaded for some reason.
        // `event.data` is the error in this case
        break;
      case 'finally':
        // The last event before cleaning up
        break;
    }
  }

  reloadPage(seriesId: number, moduleId: number) {
    this.router.navigate(['/user/videos/' + seriesId + '/' + moduleId], {
      queryParams: {
        video_active: true
      }
    });
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
